import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const BonusActivationSuccessPopup = props => {
  const {
    data: { bonus },
    id,
  } = props;

  const onCloseHandler = useCallback(() => NotificationManager.removeNotification(id), [id]);

  return (
    <div className="bonus-activation-toast">
      <Icon className="bonus-activation-toast__icon" name="success-bold" />

      <div className="bonus-activation-toast__wrapper">
        <p className="bonus-activation-toast__title">{bonus}</p>
        <Label
          className="bonus-activation-toast__subtitle"
          message="bonus_successfully_activated"
        />
      </div>

      <Icon className="bonus-activation-toast__close" name="close" onClick={onCloseHandler} />
      <div className="bonus-activation-toast__timer" />
    </div>
  );
};

BonusActivationSuccessPopup.propTypes = {
  data: PropTypes.shape({
    bonus: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BonusActivationSuccessPopup;
